import React, { createContext, useState, useEffect, useContext } from 'react';
const ThemeContext = createContext();

const DEFAULT_THEME = 'lara-dark-blue';
const AVAILABLE_THEMES = new Set(['lara-dark-blue', 'lara-light-blue']);

export const useTheme = () => {
  return useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(DEFAULT_THEME);

  useEffect(() => {
    const isLightTheme = theme.includes('light');
    document.body.setAttribute('data-theme', isLightTheme ? 'light' : 'dark');

    const currentThemeLink = document.getElementById('theme-link');
    if (currentThemeLink?.dataset.themeName === theme) {
      return undefined;
    }

    const nextThemeLink = document.createElement('link');
    nextThemeLink.id = 'theme-link-pending';
    nextThemeLink.dataset.themeName = theme;
    nextThemeLink.rel = 'stylesheet';
    nextThemeLink.href = `${process.env.PUBLIC_URL || ''}/themes/${theme}/theme.css`;

    const handleLoad = () => {
      currentThemeLink?.remove();
      nextThemeLink.id = 'theme-link';
    };

    nextThemeLink.addEventListener('load', handleLoad, { once: true });
    document.head.appendChild(nextThemeLink);

    return () => {
      nextThemeLink.removeEventListener('load', handleLoad);
      if (nextThemeLink.id === 'theme-link-pending') {
        nextThemeLink.remove();
      }
    };
  }, [theme]);

  const changeTheme = (newTheme) => {
    if (newTheme === theme || !AVAILABLE_THEMES.has(newTheme)) return;
    setTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme: changeTheme, isThemeLoading: false }}>
      {children}
    </ThemeContext.Provider>
  );
};